import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    fetchPolicyTypesFailedAction,
    fetchPolicyTypesSuccessAction,
} from '../actions/policyType';
type State = {
    policyType: {
        byId: { [id: string]: any } | {};
        allIds: Array<string | any>;
    };
    loading: boolean;
    attempted: boolean;
    errorMessage: null | any;
};
const INITIAL_STATE: State = {
    policyType: {
        byId: {},
        allIds: [],
    },
    loading: false,
    attempted: false,
    errorMessage: null,
};

const fetchPolicyTypes = (state: State): State => {
    return {
        ...state,
        loading: true,
        attempted: true,
    };
};

const fetchPolicyTypesSuccess = (
    state: State,
    action: PayloadAction<fetchPolicyTypesSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        policyType: {
            ...state.policyType,
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchPolicyTypesFailed = (
    state: State,
    action: PayloadAction<fetchPolicyTypesFailedAction>,
): State => {
    return {
        ...state,
        errorMessage: action.payload.body,
        loading: false,
    };
};

const clearPolicyTypes = (): State => {
    return {
        ...INITIAL_STATE,
    };
};

const policyType = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_POLICY_TYPES]: fetchPolicyTypes,
    [ActionTypes.FETCH_POLICY_TYPES_SUCCESS]: fetchPolicyTypesSuccess,
    [ActionTypes.FETCH_POLICY_TYPES_FAILED]: fetchPolicyTypesFailed,
    [ActionTypes.CLEAR_POLICY_TYPE]: clearPolicyTypes,
});

export default policyType;
